<!-- 2021年9月及以后账单导出 -->
<template>
  <ExportBill
    :submiting="submiting"
    :min-date="minDate"
    :max-date="maxDate"
    :disable-pick="disabled"
    @on-submit="onSubmit"
  >
    <div
      class="tips"
    >
      <p>说明：</p>
      <ol>
        <li>仅支持导出已出账单；</li>
        <li>账单导出时间为每日8:00~22:30；</li>
        <li>选择多个月份时数据量较大，每次建议少量选择，具体请以邮件内容为准；</li>
      </ol>
    </div>
  </ExportBill>
</template>

<script>
import Dialog from 'vant/lib/dialog';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import ExportBill from '@/views/bill/components/ExportBill';
import STATUS from '@/constants/status';
import ProfitApi from '@/api/profit';
import tracker from '@/util/tracker';

import 'vant/lib/dialog/style';

const BILL_DATE = 3;

export default {
  name: 'ExportBillAfterTimeNode',
  components: {
    ExportBill,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      submiting: false,
      minDate: new Date(2021, 8, 1),
      disabled: false,
    };
  },
  computed: {
    ...mapState(['accountType']),
    maxDate() {
      return dayjs().date() <= BILL_DATE ? new Date(dayjs().subtract(2, 'month')) : new Date(dayjs().subtract(1, 'month'));
    },
  },
  created() {
    this.getMinMonth();
  },
  methods: {
    async getMinMonth() {
      const accountType = this.accountType;
      const { code, message, data } = await ProfitApi.getMinMonth(accountType);
      if (code === STATUS.SUCCESS) {
        this.disabled = false;
        // 当月合作的商家不能导出账单
        if (!data) {
          this.$dialog.toast('当前无账单可以导出，请下月4号后再来~');
          this.disabled = true;
        } else {
          this.minDate = dayjs(data).toDate();
        }
      } else {
        this.$dialog.toast(message);
      }
    },
    async onSubmit(values) {
      const formData = {
        ...values,
      };

      if (!formData.startBillMonth || !formData.endBillMonth || !formData.email) {
        return;
      }

      formData.email = formData.email.trim();

      tracker.sendEvent(this.$BID.EXPORT_AFTER_SUBMIT);
      this.submiting = true;

      try {
        const { code, message } = await ProfitApi.sendBillMailAfterTimeNode(formData);
        if (code === STATUS.SUCCESS) {
          Dialog.alert({
            message: '账单导出申请已提交，请稍后在邮件中查收！因数据量较大，请耐心等待',
          }).then(() => {
            this.$router.go(-1);
          });
        } else {
          this.$dialog.toast(message || '导出失败，请稍后后重试');
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.submiting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  margin: 30px 10px;
  color: #969799;
  font-size: 24px;
  text-align: left;
}
ol {
  padding: 0 30px;
  li {
    list-style: decimal;
  }
}
</style>
